import { useContext, JSX, useState } from 'react';
import {
    Handle,
    Position,
    useReactFlow,
    useUpdateNodeInternals,
    ReactFlowInstance,
    Node
} from '@xyflow/react';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import {
    Settings,
    Add,
    Remove,
    Delete
} from '@mui/icons-material';
import { IconButton } from "@mui/material";

function WorkflowParallelNode({ id, data, selected }: { id: any, data: any, selected: any }): JSX.Element {
    const context: any = useContext(WorkflowContext);
    let startingNumber: number = data.inputCount ?? 2;
    const reactFlowInstance: ReactFlowInstance = useReactFlow();
    const [inputCount, setInputCount] = useState(startingNumber);
    const updateNodeInternals = useUpdateNodeInternals();
    // console.log(data);

    function handleAddHandle(): void {
        if (inputCount < 21) {
            let count: number = inputCount + 1;
            setInputCount(count);
            updateNodeInternals(id);
            updateNode(count)
        }
    }

    function updateNode(count: number): void {
        let node: any = reactFlowInstance.getNode(id);
        node.data.inputCount = count;

        let allNodes: Node[] = reactFlowInstance.getNodes();
        let newAllNodes: Node[] = [node];
        for (const nde of allNodes) {
            if (nde.id !== node.id) {
                newAllNodes.push(nde);
            }
        }
        // reactFlowInstance.setNodes(newAllNodes);
        context.updateLayoutNodes(newAllNodes);

    }

    function handleRemoveHandle(): void {
        if (inputCount > 2) {
            let count: number = inputCount - 1;
            setInputCount(count);
            updateNodeInternals(id);
            updateNode(count)

            let edges = reactFlowInstance.getEdges();
            let newEdges = [];
            for (const edge of edges) {
                if (edge.target !== ('parallel-source-' + count)) {
                    newEdges.push(edge);
                }
            }
            // reactFlowInstance.setEdges(newEdges);
            context.updateLayoutEdges(newEdges);
        }
    }

    function handleShowMergeConfigurationClick() {
        let node = reactFlowInstance.getNode(id);
        context.setActiveEditParallelNode(node);
    }

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }

    function handleNodeDelete(): void {
        let nodes: Node[] = reactFlowInstance.getNodes();
        let updatedNodes: Node[] = nodes.filter( (node: any): boolean => node.id !== id );
        context.updateLayoutNodes(updatedNodes);
    }


    return (
        <div className={ "workflow-node parallel " + id + " " + (successfulTest()) }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            <Handle type="target" id="parallel-target" position={Position.Top} >
                <span className="handle-label top" >{"Input"}</span>
            </Handle>
            <Handle type="target" id="parallel-target-left" position={Position.Left} >
                <span className="handle-label left" >{"Input"}</span>
            </Handle>
            <div className="node__layout">
                <div className="node__layout">
                    <div className="layout__top">
                        <span className="parallel-icon" />
                        <span className={ "label-span" }>
                             { (typeof data?.label === 'string' && data.label.length > 0) ? data.label : 'Parallel Node' }
                        </span>
                    </div>
                    <div className="layout__middle">
                        <IconButton onClick={ handleNodeDelete } >
                            <Delete />
                        </IconButton>
                    </div>
                    <div className="layout__bottom">
                        {/*<span className="action-span nodrag" onClick={ handleShowMergeConfigurationClick }>*/}
                        {/*    <Settings />*/}
                        {/*</span>*/}
                        <div className="top__buttons">
                        <span className="button nodrag" title="Add Input" onClick={ handleAddHandle }>
                            <Add />
                        </span>
                        <span className="button nodrag" title="Remove Input" onClick={ handleRemoveHandle }>
                            <Remove />
                        </span>
                        </div>
                    </div>
                </div>
                <Handle type="target" id="parallel-exit" position={Position.Right} >
                    <span className="handle-label right" >{"Exit"}</span>
                </Handle>
                { Array.from({ length: inputCount }).map( (_: any, index: number): JSX.Element => {
                    const left: number = (100 / (inputCount + 1))
                    const leftValue: string = left * (index + 1) + '%'
                    return (
                        <Handle
                            key={ 'parallel-source-' + index + '-handle' }
                            type="source"
                            id={ 'parallel-source-' + index }
                            style={ { left: leftValue  } }
                            position={Position.Bottom} >
                            <span className="handle-label bottom" >{ "Path " + (index + 1) }</span>
                        </Handle>
                    );
                } )  }
            </div>
        </div>
    );
}

export default WorkflowParallelNode;